import { useContext, useEffect, useMemo } from 'react'
import { UserListItemDto } from '../config/userConfig'
import useUsers from './useUsers'
import AuthorizationContext from '../context/AuthorizationContext'

export interface Props {
    currentMailbox: string
    currentMailboxFullName: string
    currentUser?: UserListItemDto
    currentEmail?: string
}

export default function useUser(): Props {
    const { user, mailbox } = useContext(AuthorizationContext)
    const { loaded, users, getUserByEmail } = useUsers()

    const currentUser = useMemo(() => {
        return user ? getUserByEmail(user.username) : undefined
    }, [loaded, user])

    const currentMailbox = useMemo(() => mailbox || user?.username, [mailbox, user?.username])

    useEffect(() => {
        console.debug(`Detected currentMailbox change: ${currentMailbox}.`)
    }, [currentMailbox])

    const currentMailboxFullName = useMemo(() => getUserByEmail(currentMailbox)?.fullName, [currentMailbox, users])

    return {
        currentMailbox: currentMailbox,
        currentMailboxFullName: currentMailboxFullName,
        currentUser: currentUser,
        currentEmail: currentUser?.email,
    }
}
